<template>
  <div
    class="ncrm-privacy-bar"
    :class="{ 'ncrm-privacy-bar--track': track }"
    :style="{ height: `${height}px` }"
    role="img"
    :aria-label="ariaLabel"
  >
    <div class="ncrm-privacy-bar__fill" :style="{ width: `${widthPct}%` }">
      <span
        v-for="segment in segments"
        :key="segment.key"
        class="ncrm-privacy-bar__segment"
        :style="{ width: `${segment.pct}%`, background: segment.color }"
        :title="segment.title"
      >
        <template v-if="showValues && segment.pct >= 8">{{ segment.value }}</template>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "NcrmPrivacyStackedBar",
  props: {
    // Fiecare segment: { key, pct, color, value, title }.
    segments: { type: Array, default: () => [] },
    widthPct: { type: Number, default: 100 },
    height: { type: Number, default: 24 },
    showValues: { type: Boolean, default: false },
    // `track` desenează fundalul barei, pentru distribuții care însumează 100%.
    track: { type: Boolean, default: false },
    ariaLabel: { type: String, default: "" },
  },
};
</script>

<style scoped>
.ncrm-privacy-bar { width: 100%; }
.ncrm-privacy-bar--track { background: rgba(var(--v-theme-on-surface), 0.07); border-radius: 999px; overflow: hidden; }
.ncrm-privacy-bar__fill { display: flex; height: 100%; border-radius: 6px; overflow: hidden; }
.ncrm-privacy-bar--track .ncrm-privacy-bar__fill { border-radius: 999px; }
.ncrm-privacy-bar__segment {
  display: flex; align-items: center; justify-content: center; min-width: 2px;
  color: rgb(var(--v-theme-on-success)); font-size: 12px; font-weight: 600;
}
</style>
